import { InquiryEntryType } from '@interfaces/inquiries';
import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.inquiries.share;
export const inquiriesInquiryToShareSelector = (state: RootState) => getState(state).inquiryToShare;
export const inquiriesShareSelectedSupplementsSelector = (state: RootState) =>
  getState(state).shareSelectedSupplements;
export const inquiriesShareUrlSelector = (state: RootState) => getState(state).shareUrl;
export const inquiriesShareUrlIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const inquiriesShareUrlErrorSelector = (state: RootState) => getState(state).error;
export const sharedInquiryResponseSelector = (state: RootState) => getState(state).sharedResponse;
export const sharedInquiryResponseTypeSelector = (state: RootState): null | InquiryEntryType => {
  const data = sharedInquiryResponseSelector(state);
  if (!data) {
    return null;
  }
  if (Array.isArray(data?.inquiryResponseDetailsDtos) && data?.inquiryResponseDetailsDtos.length) {
    return InquiryEntryType.Supplement;
  }
  if (
    Array.isArray(data?.medicationInquiryResponseDetailsDtos) &&
    data?.medicationInquiryResponseDetailsDtos.length
  ) {
    return InquiryEntryType.Medication;
  }
  return null;
};
